import { CloudFunction } from "../enums/cloud-function.enum";

export const CRON_JOB_FREQUENCY_DICT: Record<string, string> = {
    [CloudFunction.cron_scheduled_procedure]: "Every day at 2AM CDT/GMT-5",
    [CloudFunction.cron_purchasing_ordered_and_received_notifications]: "Every 15 minutes Monday-Friday CDT/GMT-5",
    [CloudFunction.cron_purchasing_expected_arrival_notifications]: "Every day at 12AM Monday-Friday CDT/GMT-5",
    [CloudFunction.cron_purchasing_unreadied_items_notifications]: "Every day at 12AM Monday-Friday CDT/GMT-5",
    [CloudFunction.cron_shipping_manager_skid_creation_notifications]: "Every 15 minutes Monday-Friday CDT/GMT-5",
    [CloudFunction.cron_update_roto_machine_approximate_daily_cycle_count]: "Every morning at 7am CDT/GMT-5",
    [CloudFunction.cron_add_recent_logins]: "Every hour of every day of the week",
    [CloudFunction.cron_find_new_user_devices]: "Every day at 11AM and 11PM Monday-Friday CDT/GMT-5",
    [CloudFunction.cron_load_all_gmail_users]: "Every Monday at 12AM CDT/GMT-5",
    [CloudFunction.cron_metals_project_tasks_completed_notification]: "Every day at 5AM CDT/GMT-5",
    [CloudFunction.cron_maintenance_task_review_notification]: "Every weekday at 6AM CDT/GMT-5",
    [CloudFunction.cron_complaint_log_scheduled_products_notification]: "Every weekday at 9AM CDT/GMT-5",
    [CloudFunction.cron_release_scheduled_ordered_products]: "Every day at 6AM CDT/GMT-5",
    [CloudFunction.cron_ups_shipment_tracking_updates]: "3x daily — ~6-7AM, 12-1PM, 5-6PM CT (fixed UTC, shifts 1hr with DST)",
    [CloudFunction.cron_c3_inventory_threshold_report]: "Every Thursday at 4PM CDT/GMT-5",
    [CloudFunction.cron_plastics_daily_production_rollup]: "Every night at 12:30AM CDT / 11:30PM CST (fixed UTC)",
    [CloudFunction.cron_mold_checkup_daily_summary]: "Every day at 9AM America/Chicago (adjusts for daylight saving time)",
}

export const CRON_JOB_FREQUENCY_STRING_DICT: Record<string, string> = {
    [CloudFunction.cron_scheduled_procedure]: '0 7 * * *',
    [CloudFunction.cron_purchasing_ordered_and_received_notifications]: '*/15 * * * 1-5',
    [CloudFunction.cron_purchasing_expected_arrival_notifications]: '0 5 * * 1-5',
    [CloudFunction.cron_purchasing_unreadied_items_notifications]: '0 5 * * *',
    [CloudFunction.cron_shipping_manager_skid_creation_notifications]: '*/15 * * * 1-5',
    [CloudFunction.cron_update_roto_machine_approximate_daily_cycle_count]: '0 12 * * *',
    [CloudFunction.cron_add_recent_logins]: '0 * * * *',
    [CloudFunction.cron_find_new_user_devices]: '0 4,16 * * *',
    [CloudFunction.cron_load_all_gmail_users]: '0 5 * * 1',
    [CloudFunction.cron_metals_project_tasks_completed_notification]: '0 10 * * *',
    [CloudFunction.cron_maintenance_task_review_notification]: '0 11 * * 1-5',
    [CloudFunction.cron_complaint_log_scheduled_products_notification]: '0 14 * * 1-5',
    [CloudFunction.cron_release_scheduled_ordered_products]: '0 11 * * *',
    [CloudFunction.cron_ups_shipment_tracking_updates]: '0 12,18,23 * * *',
    [CloudFunction.cron_c3_inventory_threshold_report]: '0 21 * * 4',
    [CloudFunction.cron_plastics_daily_production_rollup]: '30 5 * * *',
    [CloudFunction.cron_mold_checkup_daily_summary]: '0 14,15 * * *',
}
